import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { IBaseDto } from '@http/clients/reporting-app/base-dto.service';
import { ChangeOrderStatusService } from '@http/clients/reporting-app/change-order-status.service';
import { ReportsService } from '@services/reports.service';
import { EditorComponentBase, GenericDropdownMultiselectComponent } from 'ngx-lib';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-reporting-change-order-status-editor',
    templateUrl: './reporting-change-order-status-editor.component.html',
    styleUrls: ['./reporting-change-order-status-editor.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [GenericDropdownMultiselectComponent]
})
export class ReportingChangeOrderStatusEditorComponent
    extends EditorComponentBase<number[] | null>
    implements OnInit, OnDestroy
{
    items: IBaseDto[];
    selectedItems?: IBaseDto[];
    subscription?: Subscription;

    constructor(
        private readonly changeOrderStatusService: ChangeOrderStatusService,
        private readonly reportsService: ReportsService
    ) {
        super();
        this.items = [];
    }

    async ngOnInit(): Promise<void> {
        this.items = await this.changeOrderStatusService.getAll();

        this.subscription = this.reportsService.selectedProperty$.subscribe(async (ready) => {
            if (!ready || !this.items?.length) return;

            if (this.bindingProperty?.length && Array.isArray(this.bindingProperty)) {
                const selectedIds = new Set(this.bindingProperty);
                this.selectedItems = this.items.filter((item) => selectedIds.has(item.id));
            } else {
                this.selectedItems = [];
            }
        });
    }

    ngOnDestroy(): void {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    onSelectedItemsChange() {
        if (this.selectedItems?.length) {
            this.bindingProperty = this.selectedItems.map((obj) => obj.id);
        } else {
            this.bindingProperty = null;
        }
        this.valueChange.emit();
    }
}
